import React from "react";
import { useNavigate } from "react-router-dom";
import { Eye, X } from "lucide-react";
import { getViewAs, clearViewAs, isAdmin } from "../access";

// Shown to an admin who is previewing the site as another audience.
export default function PreviewBar() {
  const navigate = useNavigate();
  const v = getViewAs();
  if (!isAdmin() || !v) return null;
  return (
    <div className="no-print bg-amber-400 text-slate-900 px-4 py-2 flex items-center justify-center gap-3 text-sm font-semibold" data-testid="preview-bar">
      <Eye className="h-4 w-4" />
      <span>Previewing as <span className="uppercase tracking-wide">{v}</span> — this is exactly what they see.</span>
      <button
        data-testid="preview-exit"
        onClick={() => { clearViewAs(); navigate("/admin/views"); }}
        className="inline-flex items-center gap-1 rounded-full bg-slate-900 text-white px-3 py-1 text-xs font-bold hover:bg-slate-700 transition-colors"
      >
        <X className="h-3.5 w-3.5" /> Exit preview
      </button>
    </div>
  );
}
